// @react/hooks/useAffiliateTracking.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { affiliateTrackingStore } from '@core/stores';

/**
 * React hook for Click operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useAffiliateTracking } from '@react/hooks';
 *
 * const ClickList = observer(() => {
 *   const store = useAffiliateTracking();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useAffiliateTracking() {
  return affiliateTrackingStore;
}
